module.exports = __webpack_public_path__ + "img/left-arrow-icon.9b2deb98.svg";